import { Component} from '@angular/core';
//import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
import * as firebase from 'firebase';

import { Router }  from '@angular/router';

import { MemberService } from '../member/member.service';

import { Member } from '../member/member';

@Component({
  selector: 'cef-member',
  templateUrl: './webadmin.component.html',
  styleUrls: ['./style.css']
})

export class WebadminComponent {
	//profileData: FirebaseObjectObservable<any>;
	memberProfile = new Member();
	avatar = [0,0,0,0];
	//constructor(public af: AngularFire, private router: Router, private memberService: MemberService) {
	constructor(private router: Router, private memberService: MemberService) {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				let db = firebase.database();
			    db.ref('profile/'+user.uid).once('value').then(
					(snapshot:any) => {
						if (snapshot.val()){
							this.memberProfile = snapshot.val();
							if (this.memberProfile.avatar){
								this.avatar=this.memberProfile.avatar;
							}
						}				
					}
				)
			} else {
				console.log("no login!");
				this.router.navigate(['/login']);
			}
		})
	}

	sendMail(){
		this.memberService.sendMail();
	}
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/webadmin/webadmin.component.ts